import {
	LoginRequest,
	LoginResponse,
	SignUpRequest,
	ForgotPasswordRequest,
	ForgotPasswordOtpRequest,
	ResetPasswordRequest,
	ServiceFeeRangeRequest,
	ServiceFeeRangeResponse,
} from "../types";
import { api } from "./api";

// Inject auth endpoints into the main API
export const authApi = api.injectEndpoints({
	endpoints: (builder) => ({
		login: builder.mutation<LoginResponse, LoginRequest>({
			query: (credentials) => ({
				url: "/admin/v1/auth/login",
				method: "POST",
				body: credentials,
			}),
		}),
		signUp: builder.mutation<any, SignUpRequest>({
			query: (data) => ({
				url: "/admin/v1/auth/signup",
				method: "POST",
				body: data,
			}),
		}),
		forgotPassword: builder.mutation<any, ForgotPasswordRequest>({
			query: (data) => ({
				url: "/admin/v1/auth/forgot-password",
				method: "POST",
				body: data,
			}),
		}),
		forgotPasswordOtp: builder.mutation<any, ForgotPasswordOtpRequest>({
			query: (data) => ({
				url: "/admin/v1/auth/forgot-password/verify-otp",
				method: "POST",
				body: data,
			}),
		}),
		resetPassword: builder.mutation<any, ResetPasswordRequest>({
			query: (data) => ({
				url: "/admin/v1/auth/reset-password",
				method: "POST",
				body: data,
			}),
		}),
		serviceFeeRange: builder.mutation<any, ServiceFeeRangeRequest>({
			query: (data) => ({
				url: "/admin/v1/misc/service-fee",
				method: "POST",
				body: data,
			}),
			invalidatesTags: ["Misc"],
		}),
		getServiceFeeRange: builder.query<ServiceFeeRangeResponse, void>({
			query: () => "/admin/v1/misc/service-fee",
			providesTags: ["Misc"],
		}),
	}),
});

export const {
	useLoginMutation,
	useSignUpMutation,
	useForgotPasswordMutation,
	useForgotPasswordOtpMutation,
	useResetPasswordMutation,
	useServiceFeeRangeMutation,
	useGetServiceFeeRangeQuery,
} = authApi;
